import NotFoundRouter from "./router/not-found-router";

export default [NotFoundRouter];